import React from "react";
import content from "../content/overview";
import {useContent} from "../customHooks/useContent";
import {generateRandomKey} from "../utils/generateRandomKey";
import {PageHeader} from "./PageHeader";
import ReactHtmlParser from 'react-html-parser';
import {initSitesMap} from "../maps/initSitesMap";
import {Map} from "./Map";

export const Overview = () => {
    const text = useContent(content);

    const overviewSubtitle = {
        university: text.university,
        institute: text.institute,
        department: text.department
    };

    return (
        <div>
            <PageHeader overviewSubtitle={overviewSubtitle} imageClass="header-main"/>
            <main>
                <div className="container">
                    <div className="row">
                        <section className="col-12">
                            {text?.main?.map(paragraph => <p key={generateRandomKey()}>{ReactHtmlParser(paragraph)}</p>)}
                        </section>
                    </div>
                </div>
                <div className="container">
                    <div className="row">
                        <section className="col-12">
                            <div id="sitesMap" className="map">
                                <Map mapData={initSitesMap} additionalData={text.map}/>
                            </div>
                        </section>
                    </div>
                </div>
            </main>
        </div>
        );
};
